module.exports = __webpack_public_path__ + "img/37.0141c442.jpg";